<template>
	<b-card>
		<div slot="header">
			<span style="font-size: 15px; font-weight: bold">Mxik</span>
			<div class="card-header-actions">
				<b-input-group size="sm">
					<b-form-input v-model="search" size="sm" :placeholder="$t('contragent.filter')" autocomplete="off"/>
					<b-input-group-append>
						<b-button class="fa fa-search" disabled/>
						<b-button size="sm" class="mr-3 ml-3" variant="outline-primary" v-if="$can('create', 'item')" @click="createForm">
							<i class="fa fa-plus"></i>
						</b-button>
					</b-input-group-append>
				</b-input-group>
			</div>
		</div>
		<b-overlay :show="loading" rounded opacity="0.7">
			<b-card-body>
				<b-table hover striped bordered show-empty :items="data" :fields="fields">
					<template slot="id" slot-scope="data">
						{{ paginate(data.index, payload.page, payload.limit) }}
					</template>
					<template slot="actions" slot-scope="data">
						<b-badge @click="editForm(data.item)" variant="dark" class="cursor-pointer mr-2"><span style="font-size: 14px" class="fa fa-edit"/></b-badge>
						<b-badge @click="deleteForm(data.item.id)" variant="danger" class="cursor-pointer"><span style="font-size: 14px" class="fa fa-trash"/></b-badge>
					</template>
				</b-table>
				<nav class="text-center mt-2">
					<b-pagination-new background :total="total" layout="prev, pager, next" :page-size="payload.limit" :current-page.sync="payload.page"/>
				</nav>
			</b-card-body>
		</b-overlay>

		<!--		Create / Edit		-->
		<b-modal v-model="modal" :title="create ? 'Создавать' : 'Редактировать'">
			<b-input-group size="sm">
				<b-input-group-prepend>
					<b-button disabled>Названия</b-button>
				</b-input-group-prepend>
				<b-form-input v-model="form.mxikNameRu" size="sm" autocomplete="off"/>
			</b-input-group>
			<b-input-group size="sm" class="mt-3">
				<b-input-group-prepend>
					<b-button disabled>Код</b-button>
				</b-input-group-prepend>
				<b-form-input v-model="form.mxikCode" size="sm" autocomplete="off"/>
			</b-input-group>
			<b-input-group size="sm" class="mt-3">
				<b-input-group-prepend>
					<b-button disabled>Группа</b-button>
				</b-input-group-prepend>
				<b-form-input v-model="form.groupNameRu" size="sm" autocomplete="off"/>
			</b-input-group>
			<b-input-group size="sm" class="mt-3">
				<b-input-group-prepend>
					<b-button disabled>Класс</b-button>
				</b-input-group-prepend>
				<b-form-input v-model="form.classNameRu" size="sm" autocomplete="off"/>
			</b-input-group>
			<b-input-group size="sm" class="mt-3">
				<b-input-group-prepend>
					<b-button disabled>Позиция</b-button>
				</b-input-group-prepend>
				<b-form-input v-model="form.positionNameRu" size="sm" autocomplete="off"/>
			</b-input-group>
			<div slot="modal-footer">
				<b-button @click="modal=false" size="sm" variant="outline-danger">{{ $t('actions.cancel') }}</b-button>
				<b-button @click="save" size="sm" variant="success" class="ml-2">{{ $t('actions.save') }}</b-button>
			</div>
		</b-modal>
	</b-card>
</template>

<script>
import { BOverlay } from 'bootstrapVue2';
import { Pagination } from 'element-ui'
import MxikService from "./mxik.service";

export default {
	name: "mxik",
	components: {BOverlay, "b-pagination-new": Pagination},
	data() {
		return {
			search: '',
			payload: {
				page: 1,
				limit: 20
			},
			form: {},
			data: [],
			total: 0,
			fields: [
				{key: 'id', label: '№', class: 'text-center'},
				{key: 'mxikNameRu', label: 'Названия'},
				{key: 'mxikCode', label: 'Код', class: 'text-center'},
				{key: 'groupNameRu', label: 'Группа'},
				{key: 'classNameRu', label: 'Класс'},
				{key: 'positionNameRu', label: 'Позиция'},
				{key: 'actions', label: this.$t('incomes.actions'), class: 'text-center'}
			],
			loading: false,
			modal: false,
			create: true
		}
	},
	watch: {
		'search': {
			handler(s) {
				this.getList();
			}
		},
		'payload.page': {
			handler(p) {
				this.getList();
			}
		}
	},
	methods: {
		paginate(index, page_size, page_number) {
			--page_size;
			return (page_number * page_size) + index + 1;
		},
		getList() {
			this.loading = true
			MxikService.getList(this.search, this.payload).then(res => {
				this.data = res.data.items
				this.total = res.data.total
				this.loading = false
			}).catch(e => {
				this.loading = false
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		createForm() {
			this.create = true
			this.form = {}
			this.modal = true
		},
		editForm(data) {
			this.create = false
			this.form = Object.assign({}, data)
			this.modal = true
		},
		deleteForm(id) {
			this.loading = true
			MxikService.delete(id).then(res => {
				this.getList();
				this.$vs.notify({
					title: 'Успешно удалено!',
					color: 'success',
					icon: 'close',
					position: 'top-right'
				});
				this.loading = false
			}).catch(e => {
				this.loading = false
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		save() {
			if (this.form.mxikNameRu && this.form.mxikNameRu!='' && this.form.mxikCode && this.form.mxikCode!='' && this.form.positionNameRu && this.form.positionNameRu!='' && this.form.classNameRu && this.form.classNameRu!='' && this.form.groupNameRu && this.form.groupNameRu!='') {
				if (this.create) {
					MxikService.create(this.form).then(res => {
						this.getList();
						this.modal = false
						this.$vs.notify({
							title: 'Успешно сохранено!',
							color: 'success',
							icon: 'close',
							position: 'top-right'
						});
						this.loading = false
					}).catch(e => {
						this.loading = false
						this.$vs.notify({
							title: e.message,
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						});
					})
				} else {
					MxikService.update(this.form).then(res => {
						this.getList();
						this.modal = false
						this.$vs.notify({
							title: 'Успешно сохранено!',
							color: 'success',
							icon: 'close',
							position: 'top-right'
						});
						this.loading = false
					}).catch(e => {
						this.loading = false
						this.$vs.notify({
							title: e.message,
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						});
					})
				}
			} else {
				this.$vs.notify({
					title: 'Заполните все обязательные поля !',
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			}
		}
	},
	created() {
		this.getList();
	}
}
</script>

<style scoped>

</style>
